import React from "react";
import { createRoot } from "react-dom/client";

import { MsalProvider } from "@azure/msal-react";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material";

import { msalInstance } from "./context/AuthContext/authConfig";

import App from "./App";

import { customTheme } from "./styles/theme";
import "./variables.css";
import "./styles/styles.css";

msalInstance.handleRedirectPromise().then(() => {
	if (window.opener && window.opener !== window) {
		return;
	}

	const root = createRoot(document.getElementById("root"));

	root.render(
		<>
			<CssBaseline />
			<MsalProvider instance={msalInstance}>
				<ThemeProvider theme={customTheme}>
					<App />
				</ThemeProvider>
			</MsalProvider>
		</>,
	);
});
